export const IGNORE_BLUR_CLASS = 'dropdown-create-item'
export const CYCLED_ERROR_COUNTER = 50
